module.exports = require('./helpers/bundle-url').getBundleURL('1BiIG') + "logo.7718c6df.svg";